import {
  restrictedTypes,
  bannedWords,
  offensiveWords
} from '~/constants/SearchConstants';

export const getRestrictedType = searchTerm => {
  if (!searchTerm) {
    return null;
  }
  const trimmed = searchTerm.toLowerCase().trim();

  const restrictedIndex = [...bannedWords, ...offensiveWords].reduce(
    (prev, curr, i) => {
      const isRestricted = [trimmed, ...trimmed.split(' ')].some(
        term => term === curr
      );
      return isRestricted ? i : prev;
    },
    -1
  );

  if (restrictedIndex === -1) {
    return null;
  }
  if (restrictedIndex < bannedWords.length) {
    return restrictedTypes.BANNED;
  }
  if (restrictedIndex < bannedWords.length + offensiveWords.length) {
    return restrictedTypes.OFFENSIVE;
  }
  return restrictedTypes.PROTECTED;
};
